import api from './api';

export const authService = {
  async login(email, password) {
    const response = await api.post('/auth/login/', {
      email,
      password,
    });
    return response.data;
  },

  async googleLogin(credential) {
    const response = await api.post('/auth/google/', {
      token: credential,
    });
    return response.data;
  },

  async socialLogin(provider, token) {
    const response = await api.post('/auth/social/', {
      provider,
      id_token: token,
    });
    return response.data;
  },

  async register(userData) {
    const response = await api.post('/auth/register/', userData);
    return response.data;
  },

  async getProfile() {
    const response = await api.get('/auth/profile/');
    return response.data;
  },

  async updateProfile(userData) {
    const response = await api.patch('/auth/profile/', userData);
    return response.data;
  },

  async changePassword(currentPassword, newPassword) {
    const response = await api.post('/auth/change-password/', {
      current_password: currentPassword,
      new_password: newPassword,
    });
    return response.data;
  },

  async refreshToken(refreshToken) {
    const response = await api.post('/auth/token/refresh/', {
      refresh: refreshToken,
    });
    return response.data;
  },

  async logout() {
    // Clear tokens from localStorage
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
  },
};
